module.exports = __webpack_public_path__ + "img/join_page.588fdd9.png";